import React from "react";
import { Button } from "@material-ui/core";
import successGif from "../../../../assets/done-animation.gif";
import { Col, Row } from "react-flexbox-grid";
import { showNotification } from "@mantine/notifications";
import { IconCopy } from "@tabler/icons";
import { useNavigate } from "react-router-dom";

interface SuccessWithGeneratedLinkProps {
  onClose: () => void;
  paymentLinkBody: any;
  withCreateAppointment: boolean;
  appointmentCreated: any;
  appointment: any;
  props: any;
  profileDetails: any;
}

const SuccessWithGeneratedLink: React.FC<SuccessWithGeneratedLinkProps> = ({
  onClose,
  paymentLinkBody,
  withCreateAppointment,
  appointmentCreated,
  appointment,
  props,
  profileDetails,
}) => {
  const paymentLink = paymentLinkBody?.link ?? "";
  const aptData = withCreateAppointment ? appointmentCreated : appointment;
  const navigate = useNavigate();

  const handleCopy = () => {
    if (!paymentLink) return;
    navigator.clipboard.writeText(paymentLink);
    showNotification({
      title: "Copied",
      message: "Link copied",
      color: "green",
    });
  };

  return (
    <div className="pld-screen" style={{ textAlign: "center" }}>
      {/* SUCCESS GIF */}
      <div>
        <img src={successGif} alt="success" height="150px" />
      </div>

      {/* TITLE */}
      <div style={{ fontWeight: "bold", fontSize: "22px" }}>
        {withCreateAppointment
          ? "Appointment created successfully!"
          : "Successfully shared!"}
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          className="show-shared-options-box zy-dashed-border"
          style={{
            fontWeight: "500",
            fontSize: "18px",
          }}
        >
          {"Appointment ID: " + aptData?.id}
        </div>
      </div>

      <br />

      <div>Payment link is successfully shared to user</div>

      {/* SENT TO BOX */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="show-shared-options-box zy-dashed-border">
          {paymentLinkBody?.sendWhatsapp && (
            <>
              <Row>
                <Col xs={7}>
                  <div style={{ fontWeight: "500", textAlign: "left" }}>
                    • Sent to Whatsapp
                  </div>
                </Col>
                <Col xs={5}>
                  <div
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "left",
                    }}
                  >
                    {`+${paymentLinkBody?.whatsappNo?.countryCode ?? ""} ${paymentLinkBody?.whatsappNo?.phoneNo ?? ""}`}
                  </div>
                </Col>
              </Row>

              <br />
            </>
          )}

          {paymentLinkBody?.sendEmail && (
            <>
              <Row>
                <Col xs={7}>
                  <div
                    style={{
                      fontWeight: "500",
                      textAlign: "left",
                      lineHeight: "1.5",
                    }}
                  >
                    • Sent to Email
                  </div>
                </Col>
                <Col xs={5}>
                  <div
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "left",
                      lineHeight: "1.5",
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                    }}
                  >
                    {paymentLinkBody?.emailAddress}
                  </div>
                </Col>
              </Row>
              <br />
            </>
          )}
          {paymentLinkBody?.sendSms && (
            <>
              <Row>
                <Col xs={7}>
                  <div style={{ fontWeight: "500", textAlign: "left" }}>
                    • Sms sent
                  </div>
                </Col>
                <Col xs={5}>
                  <div
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "left",
                    }}
                  >
                    {`+${paymentLinkBody?.smsNumber?.countryCode ?? ""} ${paymentLinkBody?.smsNumber?.phoneNo ?? ""}`}
                  </div>
                </Col>
              </Row>

              <br />
            </>
          )}
          {paymentLinkBody?.sendChat && (
            <>
              <Row>
                <Col xs={7}>
                  <div style={{ fontWeight: "500", textAlign: "left" }}>
                    • Sent to chat
                  </div>
                </Col>
                <Col xs={5}>
                  <div
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "left",
                    }}
                  >
                    {`${aptData?.patientID ?? ""}`}
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>

      <div className="zy-divider"></div>

      {/* NOTE */}
      <div>
        <span style={{ fontWeight: 600 }}>Please note:</span> This link will be
        valid for only {paymentLinkBody?.linkValidMins} mins, if payment is not
        made, the appointment will be cancelled at{" "}
        <span style={{ fontWeight: 600 }}>
          {paymentLinkBody?.expireAt
            ? new Date(paymentLinkBody.expireAt)
                .toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
                .toLowerCase()
            : ""}
        </span>
        .
      </div>

      <br />

      {/* PAYMENT LINK BOX */}
      <div className="payment-link-box">
        <div className="payment-link-label">Payment link:</div>

        <div className="payment-link-url">{paymentLinkBody?.link}</div>

        <div
          className={`payment-link-copy ${!paymentLinkBody?.link ? "disabled" : ""}`}
          onClick={handleCopy}
        >
          <IconCopy
            width={20}
            height={20}
            color={!paymentLinkBody?.link ? "#c2c2c2" : "#ef7c01"}
          ></IconCopy>
        </div>
      </div>

      {/* BUTTON */}
      <div className="pld-center">
        <Button
          className="zy-btn-orange pld-main-btn"
          onClick={
            withCreateAppointment
              ? () => {
                  navigate(`/view?id=${profileDetails?.id}`, { replace: true });
                }
              : onClose
          }
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default SuccessWithGeneratedLink;
